import last from 'lodash/last';
import {
  IMTTripPhaseCities,
  IMTTripPhaseType
} from '../../../integrations/erp/apiTypes';

const transportPhaseTypes = {
  ship: IMTTripPhaseType.SHIP,
  flight: IMTTripPhaseType.FLIGHT
};

/**
 * Pick the city names from the list of cities which are part of trip's phases and format them to a string which
 * can be displayed in the UI. The list of cities should be already in the chronological order.
 * @param imtTripPhaseCities
 */
export function formatImtTripPhaseCitiesToStrings(
  imtTripPhaseCities: IMTTripPhaseCities[]
) {
  const tripPhases = imtTripPhaseCities.filter((cityData) => {
    return Object.values(transportPhaseTypes).includes(cityData.phaseType);
  });

  const cities: string[] = tripPhases.reduce(
    (cityNames: string[], tripPhase) => {
      // Prevent side by side duplicates like Helsinki, Amsterdam, Amsterdam, Helsinki
      if (last(cityNames) !== tripPhase.departureCity.name) {
        cityNames.push(tripPhase.departureCity.name);
      }
      cityNames.push(tripPhase.arrivalCity.name);
      return cityNames;
    },
    []
  );

  if (cities.length === 0) {
    return [];
  }

  if (cities.length <= 3) {
    // Trip is a round trip e.g. Helsinki -> Amsterdam -> Helsinki
    return [cities.join(' → ')];
  } else {
    // Trip is an open jaw trip e.g. Helsinki -> Amsterdam, Berlin -> Helsinki and has to be split
    // to multiple lines
    return [`${cities[0]} → ${cities[1]}`, `${cities[2]} → ${cities[3]}`];
  }
}

export function getCityNameOfHotelPhase(
  imtTripPhaseCities: IMTTripPhaseCities[]
) {
  const cityData = imtTripPhaseCities.find((cityData) => {
    return cityData.phaseType === IMTTripPhaseType.HOTEL;
  });

  if (!cityData) {
    return undefined;
  }
  return cityData.arrivalCity.name;
}
